import { render, staticRenderFns } from "./CaseCardLayout.vue?vue&type=template&id=62de71be&"
import script from "./CaseCardLayout.vue?vue&type=script&lang=js&"
export * from "./CaseCardLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports